import { IUIError, UIErrorHandlingService } from "@gtmhub/error-handling";
import { localize } from "@gtmhub/localization";
import { IExtendedRootScopeService } from "@gtmhub/shared/ng-extensions";
import { INgRedux } from "@gtmhub/state-management";
import { StateService } from "@uirouter/angularjs";
import { IComponentOptions } from "angular";
import { Unsubscribe } from "redux";
import { FilterType, IEntry, IFilter, IOrganization } from "@gtmhub/configuration/workday/models";
import { OrganizationsActions } from "@gtmhub/configuration/workday/redux/organizations-actions";

export class WizardFilterCtrl {
  jobLevels: IEntry[];
  filter: IFilter;
  filterTypeOrganizations: FilterType = FilterType.ORGANIZATIONS;
  filterTypeLocations: FilterType = FilterType.LOCATIONS;
  filterTypeManagerial: FilterType = FilterType.MANAGERIAL;
  organizationsFetched: boolean;
  reduxError: IUIError;
  provisionAllChecked: boolean;
  organizations: IOrganization[] = []; // the raw data coming from the backend
  index: number;
  searchJobLevelsPlaceholder: string;

  private unsubscribeFromStore: Unsubscribe;

  public static $inject = ["$scope", "$state", "UIErrorHandlingService", "$ngRedux", "OrganizationsActions"];
  constructor(
    private $scope: IExtendedRootScopeService,
    private $state: StateService,
    private uiErrorHandlingService: UIErrorHandlingService,
    private $ngRedux: INgRedux,
    private organizationsActions: OrganizationsActions
  ) {
    this.searchJobLevelsPlaceholder = localize("search_job_levels");
  }

  $onInit(): void {
    const bindStateToScope = (state) => {
      return {
        organizations: state.organizations.organizations,
        organizationsFetched: state.organizations.isFetched,
      };
    };
    this.unsubscribeFromStore = this.$ngRedux.connect(bindStateToScope.bind(this.$state))(this);
    this.$ngRedux.dispatch(this.organizationsActions.fetchOrganizationsIfMissing());
    this.$scope
      .watchUntilAndRejectOnError(
        () => this.organizationsFetched,
        () => this.reduxError
      )
      .then(() => {
        this.setSelectedEntries(this.filter.entries);
      })
      .catch((error) => {
        this.uiErrorHandlingService.handleModal(error);
      });
  }

  $onDestroy(): void {
    this.unsubscribeFromStore();
  }

  setSelectedEntries(entries: string[]): void {
    this.filter.selectedEntries = entries;
  }
}

export const WizardFilterComponent: IComponentOptions = {
  bindings: {
    filter: "<",
    index: "<",
    jobLevels: "<",
  },

  controller: WizardFilterCtrl,
  templateUrl: require("./filter.jade"),
  controllerAs: "$ctrl",
};
